module.exports = __webpack_public_path__ + "static/conceptSmall4-d98dd68d5b906f012e6bd9b30bdcbd70.jpg";